<template>
  <svg width="87px" height="63px"  class="weui-inline-block weui-icon-svg"
       :style="{'font-size':pxToRem(size) }"viewBox="0 0 87 63" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 57.1 (83088) - https://sketch.com -->
    <title>路径</title>
    <desc>Created with Sketch.</desc>
    <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Toast" transform="translate(-249.000000, -204.000000)" :fill="fill" fill-rule="nonzero">
        <g id="Toast-/-OK" transform="translate(172.000000, 138.000000)">
          <g id="路径">
            <path d="M83.363961,95.1933594 L77,101.55732 L102.671387,127.228707 C104.428746,128.986066 107.277988,128.986066 109.035348,127.228707 L163.900094,72.363961 L157.536133,66 L105.853367,117.682766 L83.363961,95.1933594 Z"></path>
          </g>
        </g>
      </g>
    </g>
    </svg>
</template>
<script lang="ts">
import { Component, Mixins, Prop } from 'vue-property-decorator';
import mixins from '../mixins';
@Component
export default class FitCheckbox extends Mixins(mixins) {
  @Prop({ default: '#07C160' }) fill;
  @Prop({ default: 60 }) size;
}
</script>
